import { Injectable } from '@angular/core';

import { ActionPerformed, PushNotificationSchema, PushNotifications, Token } from '@capacitor/push-notifications';
import { AppUpdateServiceService } from '../app-update/app-update-service.service';
import { AllPopupModalExecutionServiceService } from 'src/app/shared/services/all-popup-modal-execution-service.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FcmService {
  
  public tokenSubject = new BehaviorSubject<string | null>(null);
  
  constructor(private appUpdateServiceService: AppUpdateServiceService, private allPopupModalExecutionServiceService: AllPopupModalExecutionServiceService) { }
  
  initPushNotification(){
    if(this.appUpdateServiceService.getPlatform() !== 'web') this.registerPushNotification();
  }
  
  private registerPushNotification(){
    PushNotifications.requestPermissions().then((result:any) => {
      if (result.receive === 'granted') {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
      } else {
        // Show some error
        // this.allPopupModalExecutionServiceService.apiSuccessOrErrorMessage({msg: 'Please enable notifications.'})
      }
    });
    
    // On success, we should be able to receive notifications
    PushNotifications.addListener('registration',
      (token: Token) => {
        console.log('Push registration success, token: ' + token.value);
        this.tokenSubject.next(token.value);
      }
    );
    
    // Some issue with our setup and push will not work
    PushNotifications.addListener('registrationError',
      (error: any) => {
        console.error('Error on registration: ' + JSON.stringify(error));
      }
    );
    
    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener('pushNotificationReceived',
      (notification: PushNotificationSchema) => {
        console.log('Push received: ' + JSON.stringify(notification));
      }
    );
    
    // Method called when tapping on a notification
    PushNotifications.addListener('pushNotificationActionPerformed',
      (notification: ActionPerformed) => {
        console.log('Push action performed: ' + JSON.stringify(notification));
      }
    );
  }
  
  
  // setToken(token: string) {
  //   this.tokenSubject.next(token);
  // }
  
  // getToken(): string | null {
  //   return this.tokenSubject.value;
  // }
  
  // clearToken() {
  //   this.tokenSubject.next(null);
  // }
  
}
